module.exports = __webpack_public_path__ + "static/img/14.77a79ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/14.png
// module id = taQJ
// module chunks = 0